export enum LocaleType {
  CS = 'cs_CZ',
  EN = 'en_US',
}

export interface UserPreferences {
  darkMode?: boolean;
  locale?: LocaleType;
  vatPrice?: boolean;
  refreshPage?: boolean;
}

export const LocaleTypeMap: Record<string, LocaleType> = {
  cs: LocaleType.CS,
  en: LocaleType.EN,
};
